import {trackerJsClient} from './tracker_js_client';

class EzLandingsTracker {
  trackClick = ({to, type, value, miscJson}) =>
    trackerJsClient('action clicked', {
      category: 'clicked',
      to: to || null,
      type: type || null,
      value: value || null,
      misc_json: miscJson || {},
    });

  trackScroll = ({value}) =>
    trackerJsClient('scrolled into view', {
      category: 'scrolled',
      value: value || null,
    });

  trackSubmit = ({key, type, value}) =>
    trackerJsClient('submitted form', {
      category: 'submitted',
      key: key || null,
      type: type || null,
      value: value || null,
    });

  trackLocation = locationProperties =>
    trackerJsClient('inferred location', {
      category: 'Store',
      type: 'page',
      misc_json: locationProperties || {},
    });

  trackRenderedPageChanged = ({type, value}) =>
    trackerJsClient('rendered page changed', {
      category: 'Store',
      type: type || null,
      misc_json: {changes: value},
    });
}

export const EzLandingsTrackerClient = new EzLandingsTracker();
